var exports = {
  "qd": "x93eb46d8--c23e9a--layer",
  "Kk": "x93eb46d8--c23e9a--icon",
  "as": "x93eb46d8--c23e9a--large",
  "n2": "x93eb46d8--c23e9a--extra-large",
  "ox": "x93eb46d8--c23e9a--extra-bottom-margin",
};

module.exports = exports;
